import { useI18nextInstance } from "@squide/i18next";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { reviewCyclesI18NextInstanceKey } from "../../i18n/i18next.ts";
import type { PagedLookupPanelLabels } from "./PagedLookupPanel.tsx";
import { PersonScopeFilterPanel } from "./PersonScopeFilterPanel.tsx";

export interface DirectManagersFilterPanelProps {
    selectedIds: string[];
    onSelectionChange: (managerIds: string[]) => void;
    onBack: () => void;
    maxSelections?: number;
}

export function DirectManagersFilterPanel({ selectedIds, onSelectionChange, onBack, maxSelections }: DirectManagersFilterPanelProps) {
    const i18nextInstance = useI18nextInstance(reviewCyclesI18NextInstanceKey);
    const { t } = useTranslation("DirectManagersFilterPanel", { i18n: i18nextInstance });

    const getLoadedMoreMessage = useCallback((count: number) => t("liveRegion.loadedMore", { count }), [t]);
    const getRefreshedMessage = useCallback((count: number) => t("liveRegion.results", { count }), [t]);

    const labels = useMemo<PagedLookupPanelLabels>(
        () => ({
            title: t("title"),
            back: t("back"),
            searchPlaceholder: t("searchPlaceholder"),
            loading: t("loading"),
            empty: t("empty"),
            noResults: t("noResults"),
            error: t("error"),
            staleError: t("staleError"),
            getLoadedMoreMessage,
            getRefreshedMessage
        }),
        [t, getLoadedMoreMessage, getRefreshedMessage]
    );

    return <PersonScopeFilterPanel labels={labels} myScopeLabel={t("myScope")} selectedIds={selectedIds} onSelectionChange={onSelectionChange} onBack={onBack} maxSelections={maxSelections} />;
}
